import React from 'react';

export type Props = {
  className?: string;
  fill?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const CircleWithQuestionMark = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      className={props.className}
      onClick={props.onClick}
      fill='none'
    >
      <circle
        cx='12'
        cy='12'
        r='9'
        strokeWidth='3'
        strokeLinecap='round'
        stroke={props.fill || 'white'}
      />
      <path
        d='M10 9C10 8 11 7.5 12 7.5C13.0213 7.5 14 8.5 14 9.5C14 10.2248 13.6747 10.9496 12.9699 11.2936C12.4736 11.5359 12 11.9477 12 12.5V13'
        stroke={props.fill || 'white'}
        strokeWidth='2'
        strokeLinecap='round'
      />
      <circle cx='12' cy='16.5' r='1.5' fill={props.fill || 'white'} />
    </svg>
  );
});

CircleWithQuestionMark.displayName = 'CircleWithQuestionMark';
